import { Injectable } from '@angular/core';
import {
  CasualTournamentEntity,
  TournamentsQueryParams,
} from '@fantaz/shared/data-access/models';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as TournamentsActions from './tournaments.actions';
import * as TournamentsFeature from './tournaments.reducer';
import * as TournamentsSelectors from './tournaments.selectors';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class TournamentsFacade {
  /**
   * Loading
   */
  loaded$ = this.store.pipe(select(TournamentsSelectors.getTournamentsLoaded));

  filtering = toSignal(
    this.store.pipe(select(TournamentsSelectors.getTournamentFilteringState)),
  );

  loading = toSignal(
    this.store.pipe(select(TournamentsSelectors.getTournamentLoadingState)),
  );

  /**
   * Error
   */
  error$ = this.store.pipe(select(TournamentsSelectors.getTournamentsError));

  errorLoadingMore$ = this.store.pipe(
    select(TournamentsSelectors.getTournamentsErrorLoadingMore),
  );

  searchterm$ = this.store.pipe(
    select(TournamentsSelectors.getSearchGameDetailsTerm),
  );

  /**
   * All Tournaments
   */
  allTournaments$: Observable<Array<CasualTournamentEntity>> = this.store.pipe(
    select(TournamentsSelectors.getOrderedTournaments),
  );

  cashTournaments = toSignal(
    this.store.pipe(select(TournamentsSelectors.getCashTournaments)),
  );

  prizeTournaments = toSignal(
    this.store.pipe(select(TournamentsSelectors.getPrizeTournaments)),
  );

  tags$ = this.store.pipe(select(TournamentsSelectors.getFilterTags));

  pagination$ = this.store.pipe(select(TournamentsSelectors.getPagination));

  selectedTags$ = this.store.pipe(
    select(TournamentsSelectors.getTournamentSelectedTags),
  );

  isAllTournamentsLoaded$ = this.store.pipe(
    select(TournamentsSelectors.isAllTournamentsLoaded),
  );

  esRangeValues$ = this.store.pipe(
    select(TournamentsSelectors.getEsRangeValues),
  );

  gamesByEventsList$ = this.store.pipe(
    select(TournamentsSelectors.getGamesByEventsList),
  );

  constructor(private store: Store<TournamentsFeature.TournamentsState>) {}

  loadTournaments({ params }: { params: TournamentsQueryParams }) {
    this.store.dispatch(TournamentsActions.loadTournaments({ params }));
  }

  loadMoreTournaments({ params }: { params: TournamentsQueryParams }) {
    this.store.dispatch(TournamentsActions.loadMoreTournaments({ params }));
  }

  loadPageTournaments({ params }: { params: TournamentsQueryParams }) {
    this.store.dispatch(TournamentsActions.loadPageTournaments({ params }));
  }

  filterTournaments({ params }: { params: TournamentsQueryParams }) {
    this.store.dispatch(TournamentsActions.filterTournaments({ params }));
  }

  clearRoomFilters() {
    this.store.dispatch(TournamentsActions.clearRoomFilters());
  }

  clearAllFilters() {
    this.store.dispatch(TournamentsActions.clearSearchTournaments());
  }
}
